import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

interface onClickFunc {
  (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void
}

interface Props {
  pricing: number
  title: string
  buttonLabel?: string
  buttonOnClickFunc?: onClickFunc
  isAggregate: boolean
  unit?: string
}

export default function DoorPricingView(props: Props) {
  const { title, pricing, buttonLabel, buttonOnClickFunc, unit, isAggregate } =
    props

  return (
    <React.Fragment>
      <div className="box-round box-price mb20">
        <div className="title">{title}</div>
        <div className="box-price__inner">
          <div className="monthly-price -dashboard">
            <strong style={isAggregate ? { fontSize: '20px' } : {}}>
              {isAggregate
                ? '集計中'
                : `${pricing.toLocaleString('en-US')}${unit || '円'}`}
            </strong>
          </div>
          {!isAggregate && buttonLabel && (
            <div className="function">
              <a href="#" rel="nofollow" onClick={buttonOnClickFunc}>
                {buttonLabel}
              </a>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}
